import getText from 'context/language/getText';
import { get } from 'lodash';
import { REQUEST_ERROR } from '../constants';

const responseStatusIs = (error, value) => get(error, 'response.status', false) === value;
const isRequestError = error => (!responseStatusIs(error, 200));

const noNetworkError = getText('loadingError.noConnection');
const echoStatusMsg = error => get(error, 'response.statusText', noNetworkError);

const requestErrorParser = error => (
  {
    hasErrors: () => isRequestError(error),
    parse: () => (
      {
        type: REQUEST_ERROR,
        fields: null,
        message: echoStatusMsg(error)
      }
    )
  }
);

export default requestErrorParser;
